function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ff7e5d;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Praxis_f\\xFCr_Psychotherapie_Zeller-K\\xF6nig-2",
  "data-name": "Praxis f\\xFCr Psychotherapie Zeller-K\\xF6nig-2",
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M5.25,15.74V22H1.59V4.23H8.52A8,8,0,0,1,12,5,5.4,5.4,0,0,1,14.38,7a5.85,5.85,0,0,1,.82,3.07,5.11,5.11,0,0,1-1.79,4.12,7.41,7.41,0,0,1-4.95,1.51Zm0-3H8.52a3.26,3.26,0,0,0,2.22-.68,2.5,2.5,0,0,0,.76-2A3,3,0,0,0,10.73,8a2.91,2.91,0,0,0-2.12-.83H5.25Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M25.54,15.49H22.62V22H19V4.23h6.61a7.4,7.4,0,0,1,4.85,1.4,4.85,4.85,0,0,1,1.71,4,5.5,5.5,0,0,1-.78,3A5.39,5.39,0,0,1,29,14.57l3.85,7.26V22H28.88Zm-2.92-3h3a3,3,0,0,0,2.13-.7,2.51,2.51,0,0,0,.76-1.94,2.71,2.71,0,0,0-.71-2,3,3,0,0,0-2.19-.72H22.62Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M46.2,18.34H39.78L38.56,22H34.67L41.28,4.23h3.4L51.33,22h-3.9Zm-5.43-3h4.44L43,8.72Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M60.6,10.35l3.33-6.12h4.21L63,13l5.31,9H64L60.6,15.77,57.18,22H52.92l5.31-9L53.05,4.23h4.22Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M75.26,22H71.6V4.23h3.66Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M89.12,17.34a1.89,1.89,0,0,0-.73-1.6,9.65,9.65,0,0,0-2.64-1.17,18.79,18.79,0,0,1-3-1.21q-3-1.63-3-4.41a4.29,4.29,0,0,1,.81-2.57,5.32,5.32,0,0,1,2.34-1.76A8.64,8.64,0,0,1,86.27,4a8,8,0,0,1,3.39.69,5.41,5.41,0,0,1,2.31,2,5.1,5.1,0,0,1,.83,2.86H89.14a2.4,2.4,0,0,0-.77-1.9,3.2,3.2,0,0,0-2.16-.68,3.37,3.37,0,0,0-2.09.57A1.78,1.78,0,0,0,83.37,9a1.73,1.73,0,0,0,.88,1.46,9.84,9.84,0,0,0,2.57,1.09,11.11,11.11,0,0,1,4.55,2.34,4.63,4.63,0,0,1,1.43,3.46,4.26,4.26,0,0,1-1.75,3.62,7.6,7.6,0,0,1-4.7,1.31,9.07,9.07,0,0,1-3.73-.75,5.86,5.86,0,0,1-2.57-2,5.27,5.27,0,0,1-.89-3h3.68q0,2.94,3.51,2.94a3.46,3.46,0,0,0,2-.53A1.72,1.72,0,0,0,89.12,17.34Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M114.7,14.74h-7V22H104V4.23h11.57v3h-7.91v4.59h7Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M132.4,4.23v11.7a6,6,0,0,1-1.82,4.62,7,7,0,0,1-5,1.69,7.13,7.13,0,0,1-5-1.64,5.88,5.88,0,0,1-1.86-4.53V4.23h3.66V16a3.37,3.37,0,0,0,.84,2.54,3.15,3.15,0,0,0,2.31.8c2.06,0,3.1-1.08,3.14-3.25V4.23Zm-8.14-2.68a1.42,1.42,0,0,1-.48,1.09,1.7,1.7,0,0,1-1.22.45,1.69,1.69,0,0,1-1.22-.45,1.47,1.47,0,0,1-.46-1.09,1.49,1.49,0,0,1,.46-1.1A1.65,1.65,0,0,1,122.56,0a1.68,1.68,0,0,1,1.23.46A1.5,1.5,0,0,1,124.26,1.55Zm2.56,0a1.45,1.45,0,0,1,.5-1.11,1.72,1.72,0,0,1,1.2-.45,1.69,1.69,0,0,1,1.2.45,1.48,1.48,0,0,1,.48,1.11,1.47,1.47,0,0,1-.46,1.09,1.86,1.86,0,0,1-2.45,0A1.48,1.48,0,0,1,126.82,1.55Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M143.23,15.49h-2.91V22h-3.67V4.23h6.61a7.45,7.45,0,0,1,4.86,1.4,4.88,4.88,0,0,1,1.7,4,5.5,5.5,0,0,1-.78,3,5.39,5.39,0,0,1-2.39,1.94l3.85,7.26V22h-3.93Zm-2.91-3h3a3.08,3.08,0,0,0,2.14-.7,2.54,2.54,0,0,0,.75-1.94,2.71,2.71,0,0,0-.71-2,3,3,0,0,0-2.19-.72h-2.94Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M165,15.74V22h-3.67V4.23h6.94a8,8,0,0,1,3.52.73A5.45,5.45,0,0,1,174.13,7a5.84,5.84,0,0,1,.81,3.07,5.1,5.1,0,0,1-1.78,4.12,7.45,7.45,0,0,1-4.95,1.51Zm0-3h3.27a3.23,3.23,0,0,0,2.21-.68,2.5,2.5,0,0,0,.77-2A3,3,0,0,0,170.48,8a2.93,2.93,0,0,0-2.13-.83H165Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M187.92,17.34a1.89,1.89,0,0,0-.73-1.6,9.55,9.55,0,0,0-2.63-1.17,18.57,18.57,0,0,1-3-1.21q-3-1.63-3-4.41a4.24,4.24,0,0,1,.82-2.57,5.24,5.24,0,0,1,2.33-1.76A8.64,8.64,0,0,1,185.07,4a8,8,0,0,1,3.39.69,5.38,5.38,0,0,1,2.32,2,5.09,5.09,0,0,1,.82,2.86h-3.66a2.4,2.4,0,0,0-.77-1.9A3.16,3.16,0,0,0,185,6.9a3.37,3.37,0,0,0-2.09.57A1.77,1.77,0,0,0,182.18,9a1.72,1.72,0,0,0,.87,1.46,9.84,9.84,0,0,0,2.57,1.09,11.11,11.11,0,0,1,4.55,2.34,4.63,4.63,0,0,1,1.43,3.46,4.26,4.26,0,0,1-1.75,3.62,7.6,7.6,0,0,1-4.7,1.31,9.07,9.07,0,0,1-3.73-.75,5.92,5.92,0,0,1-2.57-2,5.27,5.27,0,0,1-.89-3h3.68q0,2.94,3.51,2.94a3.46,3.46,0,0,0,2-.53A1.72,1.72,0,0,0,187.92,17.34Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M201.46,12.23l3.69-8h4l-5.84,11.32V22H199.6V15.55L193.76,4.23h4Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M225.63,16.08a6.29,6.29,0,0,1-2.12,4.52,7.41,7.41,0,0,1-5,1.64,6.68,6.68,0,0,1-5.38-2.3,9.4,9.4,0,0,1-2-6.31V12.54A10.73,10.73,0,0,1,212,8a6.79,6.79,0,0,1,2.59-3,8,8,0,0,1,8.85.6,6.75,6.75,0,0,1,2.17,4.63H222a3.72,3.72,0,0,0-1-2.5,3.5,3.5,0,0,0-2.5-.77,3.08,3.08,0,0,0-2.74,1.31,7.33,7.33,0,0,0-.94,4.07v1.34a7.87,7.87,0,0,0,.87,4.21,3.06,3.06,0,0,0,2.76,1.33,3.6,3.6,0,0,0,2.53-.77,3.5,3.5,0,0,0,1-2.4Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M243.75,22h-3.66V14.38H233V22h-3.66V4.23H233v7.2h7.14V4.23h3.66Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M262.8,13.52a10.7,10.7,0,0,1-.93,4.6,7,7,0,0,1-2.66,3.05,7.3,7.3,0,0,1-4,1.07,7.38,7.38,0,0,1-3.94-1.06,7.08,7.08,0,0,1-2.68-3,10.41,10.41,0,0,1-1-4.54v-.88a10.74,10.74,0,0,1,1-4.62,7,7,0,0,1,2.67-3.06,7.83,7.83,0,0,1,7.9,0,7,7,0,0,1,2.67,3.06,10.7,10.7,0,0,1,.95,4.61Zm-3.71-.81a7.56,7.56,0,0,0-1-4.25,3.54,3.54,0,0,0-5.7,0,7.4,7.4,0,0,0-1,4.21v.87a7.63,7.63,0,0,0,1,4.22,3.51,3.51,0,0,0,5.72.05,7.52,7.52,0,0,0,1-4.21Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M279.05,7.19h-5.44V22h-3.67V7.19h-5.37v-3h14.48Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M296.85,22h-3.66V14.38h-7.14V22h-3.66V4.23h3.66v7.2h7.14V4.23h3.66Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M312,14.3h-7v4.76h8.26V22H301.3V4.23h11.89v3H305v4.24h7Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M323.19,15.49h-2.91V22h-3.67V4.23h6.61a7.45,7.45,0,0,1,4.86,1.4,4.85,4.85,0,0,1,1.71,4,5.5,5.5,0,0,1-.79,3,5.39,5.39,0,0,1-2.39,1.94l3.85,7.26V22h-3.93Zm-2.91-3h3a3.08,3.08,0,0,0,2.14-.7,2.54,2.54,0,0,0,.75-1.94,2.67,2.67,0,0,0-.71-2,3,3,0,0,0-2.19-.72h-2.94Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M343.85,18.34h-6.42L336.21,22h-3.89l6.61-17.77h3.4L349,22h-3.89Zm-5.43-3h4.44l-2.23-6.65Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M355.55,15.74V22h-3.66V4.23h6.93a8,8,0,0,1,3.52.73A5.34,5.34,0,0,1,364.68,7a5.76,5.76,0,0,1,.82,3.07,5.11,5.11,0,0,1-1.79,4.12,7.41,7.41,0,0,1-4.95,1.51Zm0-3h3.27a3.26,3.26,0,0,0,2.22-.68,2.5,2.5,0,0,0,.76-2A2.9,2.9,0,0,0,361,8a2.91,2.91,0,0,0-2.12-.83h-3.36Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M373.16,22H369.5V4.23h3.66Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M388.5,14.3h-7v4.76h8.26V22H377.8V4.23h11.89v3h-8.23v4.24h7Z",
  transform: "translate(-0.89 0.01)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M5.47,59.06h9V62H.89V59.85L9.68,47.19H.9v-3H14.23v2.1Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M28.68,54.3h-7v4.76H29.9V62H18V44.23H29.88v3H21.65v4.24h7Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M37,59.06h7.78V62H33.3V44.23H37Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M51.75,59.06h7.77V62H48.09V44.23h3.66Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M73.57,54.3h-7v4.76h8.25V62H62.87V44.23H74.76v3H66.54v4.24h7Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M84.77,55.49H81.85V62H78.19V44.23h6.6a7.45,7.45,0,0,1,4.86,1.4,4.85,4.85,0,0,1,1.71,4,5.42,5.42,0,0,1-.79,3,5.34,5.34,0,0,1-2.39,1.94L92,61.83V62H88.1Zm-2.92-3h3a3,3,0,0,0,2.14-.71,2.51,2.51,0,0,0,.76-1.93,2.68,2.68,0,0,0-.72-2,3,3,0,0,0-2.19-.72H81.85Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M102,55.81H95.15V53H102Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M111.9,54.87,110,56.92V62h-3.67V44.23H110v8.05l1.61-2.21,4.53-5.84h4.5l-6.31,7.89L120.82,62h-4.36Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M137.67,53.52a10.85,10.85,0,0,1-.92,4.6,7,7,0,0,1-2.66,3.05,7.86,7.86,0,0,1-7.9,0,7.1,7.1,0,0,1-2.69-3,10.41,10.41,0,0,1-1-4.54v-.88a10.68,10.68,0,0,1,.94-4.62,7,7,0,0,1,2.68-3.06,7.81,7.81,0,0,1,7.89,0,7,7,0,0,1,2.68,3.06,10.66,10.66,0,0,1,.94,4.61Zm-8.85-12a1.41,1.41,0,0,1-.47,1.09,1.72,1.72,0,0,1-1.22.45,1.65,1.65,0,0,1-1.22-.45,1.48,1.48,0,0,1-.47-1.09,1.5,1.5,0,0,1,.47-1.1,1.62,1.62,0,0,1,1.22-.46,1.65,1.65,0,0,1,1.22.46A1.46,1.46,0,0,1,128.82,41.55ZM134,52.71a7.48,7.48,0,0,0-1-4.25,3.54,3.54,0,0,0-5.7,0,7.41,7.41,0,0,0-1,4.21v.87a7.55,7.55,0,0,0,1,4.22,3.26,3.26,0,0,0,2.88,1.5A3.21,3.21,0,0,0,133,57.79a7.52,7.52,0,0,0,1-4.21Zm-2.57-11.16a1.42,1.42,0,0,1,.49-1.11,1.84,1.84,0,0,1,2.41,0,1.51,1.51,0,0,1,0,2.2,1.62,1.62,0,0,1-1.22.46,1.65,1.65,0,0,1-1.22-.46A1.44,1.44,0,0,1,131.39,41.55Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M156,62h-3.66l-7.13-11.69V62h-3.67V44.23h3.67l7.14,11.71V44.23H156Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M164.38,62h-3.66V44.23h3.66Z",
  transform: "translate(-0.89 0.01)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M183.09,59.75a6.3,6.3,0,0,1-2.8,1.84,11.58,11.58,0,0,1-4,.65,8,8,0,0,1-4-1,6.83,6.83,0,0,1-2.69-2.93,10.32,10.32,0,0,1-1-4.5V52.6a10.93,10.93,0,0,1,.9-4.61,6.64,6.64,0,0,1,2.59-3,7.54,7.54,0,0,1,4-1A7.37,7.37,0,0,1,181,45.49a6.44,6.44,0,0,1,2.12,4.39h-3.57a3.55,3.55,0,0,0-1.08-2.24,3.45,3.45,0,0,0-2.3-.7,3.23,3.23,0,0,0-2.84,1.4,7.35,7.35,0,0,0-1,4.18v1.13a7,7,0,0,0,1.06,4.22,3.62,3.62,0,0,0,3.11,1.43,4,4,0,0,0,2.94-.88V55.36h-3.33v-2.7h7Z",
  transform: "translate(-0.89 0.01)"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 388.83 62.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.dd70a891.svg";
export { ForwardRef as ReactComponent };